import { withProps } from 'recompose'
import { getVehicleNicknameWithoutYear } from 'helpers/vehicle'
import VehicleTile from './VehicleTile'

const withVehicleNicknameProps = withProps(({ nickname }) => ({
  modelWithoutYear: nickname ? getVehicleNicknameWithoutYear(nickname) : null
}))

export default withVehicleNicknameProps(VehicleTile)
